import React from 'react';
import { Grid } from '@bnnvara/grids';

import Header from '@/components/Header';
import { useAccount } from '@bnnvara/accounts';
import Section from '@/layouts/styled';
import ComposableGridSpacer from '@/composable-components/ComposableGridSpacer';
import Profile from '@/components/Profile';
import Topbar from '@/components/Topbar';
import withApolloClient from '@/hocs/withApolloClient';
import OnboardingInformationLink from '@/components/OnboardingInformationLink';
import Footer from '@/components/Footer';
import { FollowBrandProvider } from '@/components/FollowBrand/FollowBrandProvider';
import { PageMeta } from '@/components/PageMeta';

export const headerDataForProfile = (profile) => {
  const defaultDescription =
    "Dat is handig: jouw eigen profielpagina. De plek op BNNVARA.nl waar je jouw titels, likes, video's en artikelen terug kan vinden. Meld je gratis aan!";
  const loggedInDescription =
    "Dit is jouw plek op BNNVARA waar je jouw titels, likes, video's en artikelen terug kan vinden. We werken aan meer mogelijkheden die je kunt gebruiken!";

  const name = profile?.nickname || 'Profiel';
  const description = profile ? loggedInDescription : defaultDescription;
  const logoUrl =
    profile?.profilePicture || '/static/icons/img_avatar_placeholder.png';

  return {
    page: {
      name,
      description,
      logoUrl,
    },
  };
};

const ProfilePage = () => {
  const { profile } = useAccount();

  return (
    <FollowBrandProvider>
      <Section>
        <PageMeta
          title="Mijn profiel - BNNVARA"
          description="Dit is jouw plek. Beheer hier jouw profiel."
          type="static page"
          image="/static/icons/img_avatar_placeholder.png"
        />
        <Topbar />
        <Header headerData={headerDataForProfile(profile)} />
        <Grid>
          <ComposableGridSpacer />
          <Profile />
          <ComposableGridSpacer />
        </Grid>
        <OnboardingInformationLink />
        <Footer />
      </Section>
    </FollowBrandProvider>
  );
};

export default withApolloClient(ProfilePage);
